<template>
	<div class="p-fluid p-formgrid p-grid">
		<template v-for="idy in 10" v-bind:key="idy">
			<div class="p-field p-col-12">
				<div class="p-input-filled">
					<Skeleton height="1.193rem" width="6.5rem"/>
					<Skeleton class="validation-field p-input-filled" height="2.816rem" />
				</div>
			</div>
		</template>
	</div>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import Skeleton from 'primevue/skeleton';

export default defineComponent({
	name: "ValidationFieldSetSkeleton",
	components: {
		Skeleton,
	},
	setup() {
		return {}
	},
});
</script>

<style lang="scss" scoped>

.validation-field {
	margin-top: 0.5rem;
}

</style>
